import React from 'react';
import {useNavigate} from 'react-router-dom';
import Button from 'components/shared/Button';
import s from './ProductsByCategory.module.scss';
import {useProductCounter} from 'sdk/hooks/shop/useProductCounter';
import {useTranslation} from 'react-i18next';

import { ReactComponent as RiyalIcon } from 'images/new-icons/riyal.svg';

export type Product = {
    id: number;
    image: string;
    name: string;
    sku: string;
    created_at: string;
    currency: number;
    description: string;
    stats?: any | null;
    active: boolean;
    unique_name: string;
    category_id: number;
    desc_details?: string | null;
    price: number;
    in_stock?: boolean | null;
    salon: number;
    stock_quantity: number;
    min_stock_level?: number | null;
    reorder?: number | null;
    brand: number;
    original_price?: number | null;
    updated_at: string;
    subcategory_id: number;
    instruction?: string | null;
    ingredients?: string | null;
    store_id?: number | null;
    applicable_gender?: number;
    name_ar?: string | null;
};


type ProductCardProps = {
    product: Product;
    userId: string | undefined;
};

const ProductCard: React.FC<ProductCardProps> = ({product, userId}) => {
    const {t} = useTranslation() as any
    const navigate = useNavigate();
    const {
        productCount,
        isLoading,
        handleIncrement,
        handleDecrement,
        handleAddToBag,
    } = useProductCounter(product.id, userId, product?.price);

    return (
        <div
            className={s.card}
            onClick={() => navigate(`/product/${product.id}`)}
        >
            <div className={s.card_image}>
                <img src={product.image} alt={product.name}/>
            </div>
            <div className={s.card_info}>
                <div className={s.card_name}>{product.name}</div>


                <div className={s.card_price_wrapper}>
                    <span className={s.card_current_price}><RiyalIcon className={s.riyal_icon} />{product.price}</span>
                    {product.original_price && product.original_price > product.price && (
                        <span className={s.card_original_price}>
      <RiyalIcon className={s.riyal_icon} />{product.original_price}
    </span>
                    )}

                </div>

            </div>
            <Button
                className={s.card_button}
                wide
                darkGreen
                loading={isLoading}
                onClick={(e) => {
                    e.stopPropagation();
                    if (productCount === 0) {
                        handleAddToBag();
                    }
                }}
                count={productCount}
                onIncrement={(e) => {
                    e.stopPropagation();
                    handleIncrement();
                }}
                onDecrement={(e) => {
                    e.stopPropagation();
                    handleDecrement();
                }}
                showCounter={productCount > 0}
            >
                {productCount === 0 ? t('Add to cart') : ''}
            </Button>
        </div>
    );
};

export default ProductCard; 
